/** @prettier */
import analyticsSagas from './analytics/sagas';
import application from './application/reducer';
import applicationSagas from './application/sagas';
import customerOnboarding from './customerOnboarding/reducer';
import customerOnboardingSagas from './customerOnboarding/sagas';
import eventSagas from './event/sagas';
import openOffersSagas from './openOffers/sagas';
import search from './search/reducer';
import searchSagas from './search/sagas';
import sidebar from './sidebar/reducer';
import sidebarSagas from './sidebar/sagas';

export const reducers = {
  application,
  customerOnboarding,
  search,
  sidebar,
};

export const sagas = [
  analyticsSagas,
  applicationSagas,
  customerOnboardingSagas,
  searchSagas,
  sidebarSagas,
  openOffersSagas,
  eventSagas,
];
